export class UnauthorizedError extends Error {
  constructor(message = 'Unauthorized Error') {
    super(message);
  }
}
